/** @format */

import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar";
import Dashboard from "./components/Dashboard/Dashboard";
import SettingsPage from "./components/SettingsPage/SettingsPage"
import AnalysisPage from "./components/AnalysisPage/AnalysisPage";
import WeatherPage from "./components/WeatherPage/WeatherPage"
import MapPage from "./components/MapPage/MapPage";
import "./App.css";

function App() {
  const [selectedZone, setSelectedZone] = useState("SZone");
  useEffect(()=>{
    const script = document.createElement("script");
    script.src = "https://cdn.ux4g.gov.in/tools/accessibility-widget.js";
    script.defer = true;
    document.body.appendChild(script);
  },[]);
  
  return (
    <div className="app">
        <div style={{ display: "flex" }}>
          <Sidebar selectedZone={selectedZone} onZoneChange={setSelectedZone} />
          <div style={{ flex: 1, padding: "5px" }}>
            <Routes>
              <Route
                path="/"
                element={<Dashboard selectedZone={selectedZone} />}
              />
              <Route path="/analysis" element={<AnalysisPage/>} />
              <Route path="/weather" element={<WeatherPage />} />
              <Route path="/map" element={<MapPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Routes>
          </div>
        </div>
    </div>
  );
}

export default App;